import "bootstrap/dist/css/bootstrap.css";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { StoreProvider } from "easy-peasy";
import store from "./state/index";
import App from "./App";
import "./custom.scss";


if (typeof window !== "undefined") {
  const storageEnv = localStorage.getItem("ENV_NAME");
  const isMdHost = /\.md\b/i.test(window.location.hostname);

  if (storageEnv === "Moldova" || isMdHost) {
    document.body.classList.add("env-md");
    window.__ENV_NAME__ = "Moldova";
  }
}

//import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </BrowserRouter>,
  rootElement
);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();
